// import { createSlice } from '@reduxjs/toolkit'

// export const dataSlice = createSlice({
//   name: 'data',
//   initialState: {
//     value: [{ features: [] }, { features: [] }, { features: [] }, { features: [] }, { features: [] }],
//   },
//   reducers: {
//     setDataState: (state, action) => {
//       // console.log('action', action.payload)

//       state.value[action.payload[0]] = action.payload[1]
//     },

//   },
// })

// // Action creators are generated for each case reducer function
// export const { setDataState } = dataSlice.actions

// export default dataSlice.reducer
import axios from 'axios'
import {
     DATASET_1_REQUEST,
     DATASET_1_SUCCESS ,
     DATASET_1_FAIL,
    
    
} from '../constants/dataConstants'

export const dataReducer = (state = {
  value: [{}, []],
 
}, action) => {
  switch (action.type) {
    case `DATASET_${action.idx+1}_SUCCESS`:
     
      state.value[action.idx] = action.payload
      
      return state
    default:
      return state
  }
}